import { useEffect } from 'react'
import { useCrmIntegrationChatAvailability } from '@/hooks/useCrmIntegrationChatAvailability'
import { useCrmIntegrationChatUserAccess } from '@/hooks/useCrmIntegrationChatUserAccess'
import { hasAnyCrmIntegrationChatConnected } from '@pages/Admin/CRM/utils/crmIntegrationChatAvailability'
import { useIntegrationChatDockGlobalUnreadRefetch } from './useIntegrationChatDockGlobalUnreadRefetch'

export function useIntegrationChatDockBrowserTabVisibleRefetch(): void {
  const { isLoading, providers } = useCrmIntegrationChatAvailability()
  const hasUserAccess = useCrmIntegrationChatUserAccess()
  const scheduleGlobalUnreadRefetchRef =
    useIntegrationChatDockGlobalUnreadRefetch()

  const canSyncGlobalUnread =
    !isLoading &&
    hasAnyCrmIntegrationChatConnected(providers) &&
    hasUserAccess

  useEffect(() => {
    if (!canSyncGlobalUnread) {
      return
    }

    const onVisible = () => {
      if (document.visibilityState !== 'visible') {
        return
      }
      scheduleGlobalUnreadRefetchRef.current()
    }

    document.addEventListener('visibilitychange', onVisible)
    return () => {
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [canSyncGlobalUnread, scheduleGlobalUnreadRefetchRef])
}
